var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};

// db/extensions/BaseContainerGrid.ts
import { A } from "@adornis/base/env-info.js";
import "@adornis/base/utilTypes.js";
import { Int } from "@adornis/baseql/baseqlTypes.js";
import { Entity, Field } from "@adornis/baseql/decorators.js";
import { AdornisEntity } from "@adornis/baseql/entities/adornisEntity.js";
import { validate } from "@adornis/validation/decorators.js";
import { ValidationError } from "@adornis/validation/errors/ValidationError.js";
import { nonOptional } from "@adornis/validation/functions/nonOptional.js";
import { BaseContainer } from "./BaseContainer.js";
var BaseContainerGrid = class extends BaseContainer {
  get ensuredColumns() {
    if (typeof this.columns !== "number" || Number.isNaN(this.columns) || this.columns <= 0)
      return 3;
    return this.columns;
  }
  get ensuredRows() {
    if (typeof this.rows !== "number" || Number.isNaN(this.rows) || this.rows <= 0)
      return 1;
    return this.rows;
  }
  getColumnWidthByIndex(index) {
    const hardCodedDefinitions = this.columnSizeDefinitions.filter((def) => def.width && def.width !== "");
    const definitionForIndex = hardCodedDefinitions.find((def) => def.index === index);
    if (definitionForIndex)
      return definitionForIndex.width;
    return "1fr";
  }
};
BaseContainerGrid._class = "BaseContainerGrid";
__decorateClass([
  Field((type) => Int)
], BaseContainerGrid.prototype, "columns", 2);
__decorateClass([
  Field((type) => Int)
], BaseContainerGrid.prototype, "rows", 2);
__decorateClass([
  Field((type) => String)
], BaseContainerGrid.prototype, "gridRowGap", 2);
__decorateClass([
  Field((type) => String)
], BaseContainerGrid.prototype, "gridColumnGap", 2);
__decorateClass([
  Field((type) => Boolean)
], BaseContainerGrid.prototype, "revertDirection", 2);
__decorateClass([
  Field((type) => [BaseContainerGridColumnSize], { default: (v) => v ?? [] })
], BaseContainerGrid.prototype, "columnSizeDefinitions", 2);
__decorateClass([
  Field((type) => BaseContainerGridTableView)
], BaseContainerGrid.prototype, "tableView", 2);
BaseContainerGrid = __decorateClass([
  Entity()
], BaseContainerGrid);
var BaseContainerGridTableView = class extends AdornisEntity {
};
BaseContainerGridTableView._class = "BaseContainerGridTableView";
__decorateClass([
  validate(nonOptional()),
  Field((type) => String, { default: (v) => v ?? A.getGloballyUniqueID() })
], BaseContainerGridTableView.prototype, "_id", 2);
__decorateClass([
  Field((type) => Boolean)
], BaseContainerGridTableView.prototype, "hasVerticalSeperator", 2);
__decorateClass([
  Field((type) => Boolean)
], BaseContainerGridTableView.prototype, "hasHorizontalSeperator", 2);
__decorateClass([
  Field((type) => String)
], BaseContainerGridTableView.prototype, "thickness", 2);
__decorateClass([
  Field((type) => String)
], BaseContainerGridTableView.prototype, "colorSeperators", 2);
BaseContainerGridTableView = __decorateClass([
  Entity()
], BaseContainerGridTableView);
var BaseContainerGridColumnSize = class extends AdornisEntity {
};
BaseContainerGridColumnSize._class = "BaseContainerGridColumnSize";
__decorateClass([
  validate(nonOptional()),
  Field((type) => String, { default: (v) => v ?? A.getGloballyUniqueID() })
], BaseContainerGridColumnSize.prototype, "_id", 2);
__decorateClass([
  validate(nonOptional({ allowFalsy: true })),
  Field((type) => Int)
], BaseContainerGridColumnSize.prototype, "index", 2);
__decorateClass([
  validate(({ value }) => {
    if (value && !Number.isNaN(+value.slice(-1)[0]))
      throw new ValidationError("Bitte Einheit angeben bei der Grid Spaltenbreite");
  }),
  Field((type) => String)
], BaseContainerGridColumnSize.prototype, "width", 2);
BaseContainerGridColumnSize = __decorateClass([
  Entity()
], BaseContainerGridColumnSize);
export {
  BaseContainerGrid,
  BaseContainerGridColumnSize,
  BaseContainerGridTableView
};
